import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { GlobalMessageContext } from "../app/App";
import { Button } from "@mui/material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function GlobalMessage(props) {
  const { globalMessage: globalMessage, setGlobalMessage: setGlobalMessage } =
    React.useContext(GlobalMessageContext);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (globalMessage.globalMessage !== "") {
      setOpen(true);
    }
  }, [globalMessage]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={10000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={globalMessage.severity}
          sx={{ width: "100%" }}
        >
          {globalMessage.globalMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
